var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full"},[(_vm.loading)?_c('div',{staticStyle:{"height":"100%"}},[_c('loader',{attrs:{"size":"xxs","loader-image":false}})],1):_c('div',[(_vm.manager)?_c('manager-dashboard'):_c('employee-dashboard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }